import request from '@/utils/request'

// 会员分页列表
export function getMemberList(params) {
  return request({ url: '/api/member/list', method: 'get', params })
}

// 会员详情
export function getMemberDetail(id) {
  return request({ url: `/api/member/detail/${id}`, method: 'get' })
}

// 查询有赞储值卡余额（按手机号）
export function queryYouzanBalance(phone) {
  return request({ url: '/api/member/balance', method: 'get', params: { phone } })
}

// 导出会员列表（Excel）
export function exportMemberList(params) {
  return request({ url: '/api/member/export', method: 'get', params, responseType: 'blob' })
}

// ==================== 导入功能 ====================

// 科脉会员导入（上传CSV/Excel文件）
export function importMemberFromKemai(formData, onUploadProgress) {
  return request({ url: '/api/import/member/csv', method: 'post', data: formData, headers: { 'Content-Type': 'multipart/form-data' }, onUploadProgress, timeout: 300000 })
}

// 查询科脉导入任务进度
export function getKemaiImportTask(taskId) {
  return request({ url: `/api/import/member/csv/task/${taskId}`, method: 'get' })
}

// 查询科脉导入结果详情
export function getKemaiImportResult(taskId) {
  return request({ url: `/api/import/member/csv/task/${taskId}/result`, method: 'get' })
}

// 下载导入错误文件
export function downloadKemaiImportErrorFile(taskId) {
  return request({
    url: `/api/import/member/csv/task/${taskId}/error-file`,
    method: 'get',
    responseType: 'blob',
    timeout: 30000
  })
}

// 有赞会员导入（按时间段同步）
export function syncFromYouzan(params) {
  return request({ url: '/api/import/youzan', method: 'post', data: params })
}

// 查询有赞同步任务进度
export function getYouzanImportTask(taskId) {
  return request({ url: `/api/import/youzan/task/${taskId}`, method: 'get' })
}

